import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';


declare var Trustpilot;
@Component({
  selector: 'app-trust-pilot',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './trust-pilot.component.html',
  styleUrls: ['./trust-pilot.component.scss']
})




export class TrustPilotComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    if (typeof document !== 'undefined') {
      const element = document.getElementById('trustpilot-widget');
      this.loadTrustpilotScript().then(() => {
        const trustpilot = (window as any).Trustpilot;
        if (trustpilot && element) {
          trustpilot.loadFromElement(element);
        }
      });
    }
  }


  private loadTrustpilotScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject('Trustpilot script failed to load');
      document.body.appendChild(script);
    });
  }
}
